export const createMarkup = (text) => ({
  __html: text,
});